// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"second-text-module--textWrapper--2f1NV","textBox":"second-text-module--textBox--y0mtB"};